import { Link } from 'react-router-dom';
import { Map, ArrowLeft } from 'lucide-react';

const adminLinks = [
  {
    to: '/admin/dungeons',
    icon: Map,
    title: 'Dungeon Designer',
    description: 'Create and edit dungeon maps, rooms, triggers, and quests.',
  },
];

export function AdminDashboard() {
  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      <header className="border-b border-gray-800 bg-gray-950/80 backdrop-blur sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center gap-4">
          <Link
            to="/games"
            className="flex items-center gap-1.5 text-gray-400 hover:text-gray-200 transition-colors text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Link>
          <span className="text-gray-700">/</span>
          <h1 className="text-sm font-medium text-gray-200">Admin</h1>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 py-8">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {adminLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="group rounded-xl border border-gray-800 bg-gray-900/50 p-5 hover:border-gray-700 hover:bg-gray-900 transition-colors"
            >
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 rounded-lg bg-indigo-950 border border-indigo-800 flex items-center justify-center">
                  <link.icon className="w-4.5 h-4.5 text-indigo-400" />
                </div>
                <h2 className="text-sm font-medium text-gray-100 group-hover:text-white transition-colors">
                  {link.title}
                </h2>
              </div>
              <p className="text-xs text-gray-500 leading-relaxed">{link.description}</p>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
